import { render, staticRenderFns } from "./imgshare.vue?vue&type=template&id=b25a3cee&scoped=true&"
import script from "./imgshare.vue?vue&type=script&lang=js&"
export * from "./imgshare.vue?vue&type=script&lang=js&"
import style0 from "./imgshare.vue?vue&type=style&index=0&id=b25a3cee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25a3cee",
  null
  
)

export default component.exports